import { Alert } from 'services/alerts.service'

export const types = Object.freeze({
  SET_ALERT: '@alert/setAlert',
  CLEAR_ALERT: '@alert/clearAlert',
  FETCH_UNSEEN_ALERTS: '@alert/fetchUnseenAlerts'
})

export function setAlert(alert: Alert | null) {
  return { type: types.SET_ALERT, payload: { alert } }
}

export function clearAlert() {
  return { type: types.CLEAR_ALERT }
}

export function fetchUnseenAlerts() {
  return { type: types.FETCH_UNSEEN_ALERTS }
}
